import type { SxProps, Theme } from '@mui/material'

/** Highlight blue shared with the matched-text emphasis in SecuritySearchModal.css. */
export const SEARCH_HIGHLIGHT_COLOR = '#2962ff'

/**
 * Styles for a symbol search row's button. Rows get a little vertical breathing room; the keyboard-focused
 * row shows an inset rounded outline (TradingView style) instead of a filled background.
 */
export const getRowButtonSx = (focused: boolean): SxProps<Theme> => ({
    py: 1,
    ...(focused
        ? {
              borderRadius: '4px',
              outline: `2px solid ${SEARCH_HIGHLIGHT_COLOR}`,
              outlineOffset: '-3px'
          }
        : {})
})
